module.exports = " <div class=ui> <div class=navbar-wrapper> <div class=navbar> <div class=left> </div> <div class=title>PACO-UI</div> <div class=right></div> </div> </div> <announcement>您的爱车暂无违章记录，请继续保持</announcement> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/AnnouncementView.vue
// module id = 145
// module chunks = 1